import { ButtonCollapsible } from '@bgea-js/design-library';
import { SingleDonation as SingleDonationHP } from '@bgea-js/form-templates';
import customConfirmationHPV from "../../../../src/content/hiding-place-signup-movie/customConfirmation";
import * as React from 'react';
export default {
  ButtonCollapsible,
  SingleDonationHP,
  customConfirmationHPV,
  React
};